import { createFileRoute } from '@tanstack/react-router'

import { UnsubscribePage } from '@/modules/unsubscribe'

const UnsubscribeRoute = () => {
  const { token } = Route.useSearch()
  return <UnsubscribePage token={token} />
}

export const Route = createFileRoute('/unsubscribe')({
  staticData: { title: 'Unsubscribe' },
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: UnsubscribeRoute,
})
